import styled from 'styled-components'

const dividerColor = (props) => props.theme.global.colors['divider']

export const VerticalLine = styled.div`
  width: 1px;
  background-color: ${dividerColor};

  @media screen and (max-width: 992px) {
    display: none;
  }
`
